import type { GameFragment } from "@workspace/casino_core/fragments/GameFragment";
import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";
import GameDetailsTable from "../GameDetailsTable";
import ThemeLinksSection from "./ThemeLinksSection";
import useGameDetails from "./useGameDetails";

// List cards carry only the shared fields; the play page the full game.
type GameDetailsGame = GameFragment & Partial<SingleGameFragment>;

type Props = { game: GameDetailsGame };

const GameDetailsTooltip: FC<Props> = ({ game }) => {
  const { hasData } = useGameDetails(game);
  if (!hasData) {
    return <div />;
  }
  return (
    <div className="grid gap-4">
      <GameDetailsTable game={game} hideTitle />
      <ThemeLinksSection themes={game?.themes?.edges} />
    </div>
  );
};

export default GameDetailsTooltip;
